export default __webpack_public_path__ + "static/media/cancel-trade.2af311fd.svg";